<template>
  <div class="tab-title">
    <div class="text">{{title}}</div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'Tabtitle',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-title{
  padding: 0.2rem 0;
  position: relative;
  .text{
    padding: 0 0.2rem;
    background-color: #fff;
    position: relative;
    z-index: 1;
    display: inline;
    margin-left: 0.4rem;
    font-size: 16px;
    color: #2eaeb4;
  }
  .line{
    width: 100%;
    height: 1px;
    background-color: #dfdfdf;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    transform: scaleY(0.5);
  }
}
</style>